import { Box, Paper, Stack, Typography } from "@mui/material";
import KeyboardArrowRightRounded from "@mui/icons-material/KeyboardArrowRightRounded";
import { ProposalActionItem } from "../../../../types/proposal.types";


interface ProposalActionItemCardProps {
  item: ProposalActionItem;
}

export default function ProposalActionItemCard({
  item,
}: ProposalActionItemCardProps) {
  return (
    <Paper
      onClick={item.onClick}
      sx={{
        borderRadius: "12px",
        p: 1.5,
        boxShadow: 0,
        cursor: "pointer",
        "&:hover": { bgcolor: "#f8fafc" },
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={{
            width: 45,
            height: 45,
            borderRadius: "50%",
            bgcolor: "#f0f4f8",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          {item.icon}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "13px",
              color: "#475569",
              lineHeight: 1.5,
            }}
          >
            {item.title}
          </Typography>
          <Typography
            sx={{ fontSize: "11px", color: "#cbd5e1", lineHeight: 1.5 }}
          >
            {item.subtitle}
          </Typography>
        </Box>
        <KeyboardArrowRightRounded
          sx={{ fontSize: 18, color: "#cbd5e1", flexShrink: 0 }}
        />
      </Stack>
    </Paper>
  );
}
